import { api } from ":mods";
import { CONST, model } from "..";

export async function detailsGet(resource: number | string): Promise<model.ResourceDetails> {
  return api.getAuth(CONST.ENDPOINTS.admin.detail_resource(resource)).then((res) => {
    const p = res.data;
    p.data = p.data.resources;
    console.log("res.data is :: ", p);
    return p;
  });
}
